[
  {
    "name": "Aruba",
    "code": "ABW",
    "iata": "AW",
    "prefix": "+297"
  },
  {
    "name": "Afghanistan",
    "code": "AFG",
    "iata": "AF",
    "prefix": "+93"
  },
  {
    "name": "Angola",
    "code": "AGO",
    "iata": "AO",
    "prefix": "+244"
  },
  {
    "name": "Anguilla",
    "code": "AIA",
    "iata": "AI",
    "prefix": "+1264"
  },
  {
    "name": "Aland Islands",
    "code": "ALA",
    "iata": "AX",
    "prefix": "+35818"
  },
  {
    "name": "Albania",
    "code": "ALB",
    "iata": "AL",
    "prefix": "+355"
  },
  {
    "name": "Andorra",
    "code": "AND",
    "iata": "AD",
    "prefix": "+376"
  },
  {
    "name": "Netherlands Antilles",
    "code": "ANT",
    "iata": "AN",
    "prefix": "+599"
  },
  {
    "name": "United Arab Emirates",
    "code": "ARE",
    "iata": "AE",
    "prefix": "+971"
  },
  {
    "name": "Argentina",
    "code": "ARG",
    "iata": "AR",
    "prefix": "+54"
  },
  {
    "name": "Armenia",
    "code": "ARM",
    "iata": "AM",
    "prefix": "+374"
  },
  {
    "name": "American Samoa",
    "code": "ASM",
    "iata": "AS",
    "prefix": "+1684"
  },
  {
    "name": "Antarctica",
    "code": "ATA",
    "iata": "AQ",
    "prefix": "+672"
  },
  {
    "name": "French Southern Territories",
    "code": "ATF",
    "iata": "TF",
    "prefix": "+262"
  },
  {
    "name": "Antigua and Barbuda",
    "code": "ATG",
    "iata": "AG",
    "prefix": "+1268"
  },
  {
    "name": "Australia",
    "code": "AUS",
    "iata": "AU",
    "prefix": "+61"
  },
  {
    "name": "Austria",
    "code": "AUT",
    "iata": "AT",
    "prefix": "+42"
  },
  {
    "name": "Azerbaijan",
    "code": "AZE",
    "iata": "AZ",
    "prefix": "+994"
  },
  {
    "name": "Burundi",
    "code": "BDI",
    "iata": "BI",
    "prefix": "+257"
  },
  {
    "name": "Belgium",
    "code": "BEL",
    "iata": "BE",
    "prefix": "+32"
  },
  {
    "name": "Benin",
    "code": "BEN",
    "iata": "BJ",
    "prefix": "+229"
  },
  {
    "name": "Bonaire, Sint Eustatius and Saba",
    "code": "BES",
    "iata": "BQ",
    "prefix": "+599"
  },
  {
    "name": "Burkina Faso",
    "code": "BFA",
    "iata": "BF",
    "prefix": "+226"
  },
  {
    "name": "Bangladesh",
    "code": "BGD",
    "iata": "BD",
    "prefix": "+880"
  },
  {
    "name": "Bulgaria",
    "code": "BGR",
    "iata": "BG",
    "prefix": "+359"
  },
  {
    "name": "Bahrain",
    "code": "BHR",
    "iata": "BH",
    "prefix": "+973"
  },
  {
    "name": "Bahamas",
    "code": "BHS",
    "iata": "BS",
    "prefix": "+1242"
  },
  {
    "name": "Bosnia and Herzegovina",
    "code": "BIH",
    "iata": "BA",
    "prefix": "+387"
  },
  {
    "name": "Saint Barthélemy",
    "code": "BLM",
    "iata": "BL",
    "prefix": "+590"
  },
  {
    "name": "Belarus",
    "code": "BLR",
    "iata": "BY",
    "prefix": "+375"
  },
  {
    "name": "Belize",
    "code": "BLZ",
    "iata": "BZ",
    "prefix": "+501"
  },
  {
    "name": "Bermuda",
    "code": "BMU",
    "iata": "BM",
    "prefix": "+1441"
  },
  {
    "name": "Bolivia",
    "code": "BOL",
    "iata": "BO",
    "prefix": "+591"
  },
  {
    "name": "Brazil",
    "code": "BRA",
    "iata": "BR",
    "prefix": "+55"
  },
  {
    "name": "Barbados",
    "code": "BRB",
    "iata": "BB",
    "prefix": "+1246"
  },
  {
    "name": "Brunei",
    "code": "BRN",
    "iata": "BN",
    "prefix": "+673"
  },
  {
    "name": "Bhutan",
    "code": "BTN",
    "iata": "BT",
    "prefix": "+975"
  },
  {
    "name": "Bouvet Island",
    "code": "BVT",
    "iata": "BV",
    "prefix": "+47"
  },
  {
    "name": "Botswana",
    "code": "BWA",
    "iata": "BW",
    "prefix": "+267"
  },
  {
    "name": "Central African Republic",
    "code": "CAF",
    "iata": "CF",
    "prefix": "+236"
  },
  {
    "name": "Canada",
    "code": "CAN",
    "iata": "CA",
    "prefix": "+1"
  },
  {
    "name": "Cocos Islands",
    "code": "CCK",
    "iata": "CC",
    "prefix": "+61"
  },
  {
    "name": "Switzerland",
    "code": "CHE",
    "iata": "CH",
    "prefix": "+41"
  },
  {
    "name": "Chile",
    "code": "CHL",
    "iata": "CL",
    "prefix": "+56"
  },
  {
    "name": "China",
    "code": "CHN",
    "iata": "CN",
    "prefix": "+86"
  },
  {
    "name": "Ivory Coast",
    "code": "CIV",
    "iata": "CI",
    "prefix": "+225"
  },
  {
    "name": "Cameroon",
    "code": "CMR",
    "iata": "CM",
    "prefix": "+237"
  },
  {
    "name": "DR Congo",
    "code": "COD",
    "iata": "CD",
    "prefix": "+243"
  },
  {
    "name": "Republic of the Congo",
    "code": "COG",
    "iata": "CG",
    "prefix": "+242"
  },
  {
    "name": "Cook Islands",
    "code": "COK",
    "iata": "CK",
    "prefix": "+682"
  },
  {
    "name": "Colombia",
    "code": "COL",
    "iata": "CO",
    "prefix": "+57"
  },
  {
    "name": "Comoros",
    "code": "COM",
    "iata": "KM",
    "prefix": "+269"
  },
  {
    "name": "Cape Verde",
    "code": "CPV",
    "iata": "CV",
    "prefix": "+238"
  },
  {
    "name": "Costa Rica",
    "code": "CRI",
    "iata": "CR",
    "prefix": "+506"
  },
  {
    "name": "Cuba",
    "code": "CUB",
    "iata": "CU",
    "prefix": "+53"
  },
  {
    "name": "Curaçao",
    "code": "CUW",
    "iata": "CW",
    "prefix": "+599"
  },
  {
    "name": "Christmas Island",
    "code": "CXR",
    "iata": "CX",
    "prefix": "+61"
  },
  {
    "name": "Cayman Islands",
    "code": "CYM",
    "iata": "KY",
    "prefix": "+1345"
  },
  {
    "name": "Cyprus",
    "code": "CYP",
    "iata": "CY",
    "prefix": "+357"
  },
  {
    "name": "Czech Republic",
    "code": "CZE",
    "iata": "CZ",
    "prefix": "+420"
  },
  {
    "name": "Germany",
    "code": "DEU",
    "iata": "DE",
    "prefix": "+49"
  },
  {
    "name": "Djibouti",
    "code": "DJI",
    "iata": "DJ",
    "prefix": "+253"
  },
  {
    "name": "Dominica",
    "code": "DMA",
    "iata": "DM",
    "prefix": "+1767"
  },
  {
    "name": "Denmark",
    "code": "DNK",
    "iata": "DK",
    "prefix": "+45"
  },
  {
    "name": "Dominican Republic",
    "code": "DOM",
    "iata": "DO",
    "prefix": "+1809"
  },
  {
    "name": "Algeria",
    "code": "DZA",
    "iata": "DZ",
    "prefix": "+213"
  },
  {
    "name": "Ecuador",
    "code": "ECU",
    "iata": "EC",
    "prefix": "+593"
  },
  {
    "name": "Egypt",
    "code": "EGY",
    "iata": "EG",
    "prefix": "+20"
  },
  {
    "name": "Eritrea",
    "code": "ERI",
    "iata": "ER",
    "prefix": "+291"
  },
  {
    "name": "Western Sahara",
    "code": "ESH",
    "iata": "EH",
    "prefix": "+212"
  },
  {
    "name": "Spain",
    "code": "ESP",
    "iata": "ES",
    "prefix": "+34"
  },
  {
    "name": "Estonia",
    "code": "EST",
    "iata": "EE",
    "prefix": "+372"
  },
  {
    "name": "Ethiopia",
    "code": "ETH",
    "iata": "ET",
    "prefix": "+251"
  },
  {
    "name": "Finland",
    "code": "FIN",
    "iata": "FI",
    "prefix": "+358"
  },
  {
    "name": "Fiji",
    "code": "FJI",
    "iata": "FJ",
    "prefix": "+679"
  },
  {
    "name": "Falkland Islands",
    "code": "FLK",
    "iata": "FK",
    "prefix": "+500"
  },
  {
    "name": "France",
    "code": "FRA",
    "iata": "FR",
    "prefix": "+33"
  },
  {
    "name": "Faroe Islands",
    "code": "FRO",
    "iata": "FO",
    "prefix": "+298"
  },
  {
    "name": "Micronesia",
    "code": "FSM",
    "iata": "FM",
    "prefix": "+691"
  },
  {
    "name": "Gabon",
    "code": "GAB",
    "iata": "GA",
    "prefix": "+241"
  },
  {
    "name": "United Kingdom",
    "code": "GBR",
    "iata": "GB",
    "prefix": "+44"
  },
  {
    "name": "Georgia",
    "code": "GEO",
    "iata": "GE",
    "prefix": "+995"
  },
  {
    "name": "Guernsey",
    "code": "GGY",
    "iata": "GG",
    "prefix": "+441481"
  },
  {
    "name": "Ghana",
    "code": "GHA",
    "iata": "GH",
    "prefix": "+233"
  },
  {
    "name": "Gibraltar",
    "code": "GIB",
    "iata": "GI",
    "prefix": "+350"
  },
  {
    "name": "Guinea",
    "code": "GIN",
    "iata": "GN",
    "prefix": "+224"
  },
  {
    "name": "Guadeloupe",
    "code": "GLP",
    "iata": "GP",
    "prefix": "+590"
  },
  {
    "name": "Gambia",
    "code": "GMB",
    "iata": "GM",
    "prefix": "+220"
  },
  {
    "name": "Guinea-Bissau",
    "code": "GNB",
    "iata": "GW",
    "prefix": "+245"
  },
  {
    "name": "Equatorial Guinea",
    "code": "GNQ",
    "iata": "GQ",
    "prefix": "+240"
  },
  {
    "name": "Greece",
    "code": "GRC",
    "iata": "GR",
    "prefix": "+30"
  },
  {
    "name": "Grenada",
    "code": "GRD",
    "iata": "GD",
    "prefix": "+1473"
  },
  {
    "name": "Greenland",
    "code": "GRL",
    "iata": "GL",
    "prefix": "+299"
  },
  {
    "name": "Guatemala",
    "code": "GTM",
    "iata": "GT",
    "prefix": "+502"
  },
  {
    "name": "French Guiana",
    "code": "GUF",
    "iata": "GF",
    "prefix": "+594"
  },
  {
    "name": "Guam",
    "code": "GUM",
    "iata": "GU",
    "prefix": "+1671"
  },
  {
    "name": "Guyana",
    "code": "GUY",
    "iata": "GY",
    "prefix": "+592"
  },
  {
    "name": "Hong Kong",
    "code": "HKG",
    "iata": "HK",
    "prefix": "+852"
  },
  {
    "name": "Heard Island and McDonald Islands",
    "code": "HMD",
    "iata": "HM",
    "prefix": "+672"
  },
  {
    "name": "Honduras",
    "code": "HND",
    "iata": "HN",
    "prefix": "+504"
  },
  {
    "name": "Croatia",
    "code": "HRV",
    "iata": "HR",
    "prefix": "+385"
  },
  {
    "name": "Haiti",
    "code": "HTI",
    "iata": "HT",
    "prefix": "+509"
  },
  {
    "name": "Hungary",
    "code": "HUN",
    "iata": "HU",
    "prefix": "+36"
  },
  {
    "name": "Indonesia",
    "code": "IDN",
    "iata": "ID",
    "prefix": "+62"
  },
  {
    "name": "Isle of Man",
    "code": "IMN",
    "iata": "IM",
    "prefix": "+44"
  },
  {
    "name": "India",
    "code": "IND",
    "iata": "IN",
    "prefix": "+91"
  },
  {
    "name": "British Indian Ocean Territory",
    "code": "IOT",
    "iata": "IO",
    "prefix": "+246"
  },
  {
    "name": "Ireland",
    "code": "IRL",
    "iata": "IE",
    "prefix": "+353"
  },
  {
    "name": "Iran",
    "code": "IRN",
    "iata": "IR",
    "prefix": "+98"
  },
  {
    "name": "Iraq",
    "code": "IRQ",
    "iata": "IQ",
    "prefix": "+964"
  },
  {
    "name": "Iceland",
    "code": "ISL",
    "iata": "IS",
    "prefix": "+354"
  },
  {
    "name": "Israel",
    "code": "ISR",
    "iata": "IL",
    "prefix": "+972"
  },
  {
    "name": "Italy",
    "code": "ITA",
    "iata": "IT",
    "prefix": "+39"
  },
  {
    "name": "Jamaica",
    "code": "JAM",
    "iata": "JM",
    "prefix": "+1876"
  },
  {
    "name": "Jersey",
    "code": "JEY",
    "iata": "JE",
    "prefix": "+44"
  },
  {
    "name": "Jordan",
    "code": "JOR",
    "iata": "JO",
    "prefix": "+962"
  },
  {
    "name": "Japan",
    "code": "JPN",
    "iata": "JP",
    "prefix": "+81"
  },
  {
    "name": "Kazakhstan",
    "code": "KAZ",
    "iata": "KZ",
    "prefix": "+7"
  },
  {
    "name": "Kenya",
    "code": "KEN",
    "iata": "KE",
    "prefix": "+254"
  },
  {
    "name": "Kyrgyzstan",
    "code": "KGZ",
    "iata": "KG",
    "prefix": "+996"
  },
  {
    "name": "Cambodia",
    "code": "KHM",
    "iata": "KH",
    "prefix": "+855"
  },
  {
    "name": "Kiribati",
    "code": "KIR",
    "iata": "KI",
    "prefix": "+686"
  },
  {
    "name": "Saint Kitts and Nevis",
    "code": "KNA",
    "iata": "KN",
    "prefix": "+1869"
  },
  {
    "name": "South Korea",
    "code": "KOR",
    "iata": "KR",
    "prefix": "+82"
  },
  {
    "name": "Kuwait",
    "code": "KWT",
    "iata": "KW",
    "prefix": "+965"
  },
  {
    "name": "Laos",
    "code": "LAO",
    "iata": "LA",
    "prefix": "+856"
  },
  {
    "name": "Lebanon",
    "code": "LBN",
    "iata": "LB",
    "prefix": "+961"
  },
  {
    "name": "Liberia",
    "code": "LBR",
    "iata": "LR",
    "prefix": "+231"
  },
  {
    "name": "Libya",
    "code": "LBY",
    "iata": "LY",
    "prefix": "+218"
  },
  {
    "name": "Saint Lucia",
    "code": "LCA",
    "iata": "LC",
    "prefix": "+1758"
  },
  {
    "name": "Liechtenstein",
    "code": "LIE",
    "iata": "LI",
    "prefix": "+423"
  },
  {
    "name": "Sri Lanka",
    "code": "LKA",
    "iata": "LK",
    "prefix": "+94"
  },
  {
    "name": "Lesotho",
    "code": "LSO",
    "iata": "LS",
    "prefix": "+266"
  },
  {
    "name": "Lithuania",
    "code": "LTU",
    "iata": "LT",
    "prefix": "+370"
  },
  {
    "name": "Luxembourg",
    "code": "LUX",
    "iata": "LU",
    "prefix": "+352"
  },
  {
    "name": "Latvia",
    "code": "LVA",
    "iata": "LV",
    "prefix": "+371"
  },
  {
    "name": "Macao",
    "code": "MAC",
    "iata": "MO",
    "prefix": "+853"
  },
  {
    "name": "Saint Martin",
    "code": "MAF",
    "iata": "MF",
    "prefix": "+590"
  },
  {
    "name": "Morocco",
    "code": "MAR",
    "iata": "MA",
    "prefix": "+212"
  },
  {
    "name": "Monaco",
    "code": "MCO",
    "iata": "MC",
    "prefix": "+377"
  },
  {
    "name": "Moldova",
    "code": "MDA",
    "iata": "MD",
    "prefix": "+373"
  },
  {
    "name": "Madagascar",
    "code": "MDG",
    "iata": "MG",
    "prefix": "+261"
  },
  {
    "name": "Maldives",
    "code": "MDV",
    "iata": "MV",
    "prefix": "+960"
  },
  {
    "name": "Mexico",
    "code": "MEX",
    "iata": "MX",
    "prefix": "+52"
  },
  {
    "name": "Marshall Islands",
    "code": "MHL",
    "iata": "MH",
    "prefix": "+692"
  },
  {
    "name": "Macedonia",
    "code": "MKD",
    "iata": "MK",
    "prefix": "+389"
  },
  {
    "name": "Mali",
    "code": "MLI",
    "iata": "ML",
    "prefix": "+223"
  },
  {
    "name": "Malta",
    "code": "MLT",
    "iata": "MT",
    "prefix": "+356"
  },
  {
    "name": "Myanmar",
    "code": "MMR",
    "iata": "MM",
    "prefix": "+95"
  },
  {
    "name": "Montenegro",
    "code": "MNE",
    "iata": "ME",
    "prefix": "+382"
  },
  {
    "name": "Mongolia",
    "code": "MNG",
    "iata": "MN",
    "prefix": "+976"
  },
  {
    "name": "Northern Mariana Islands",
    "code": "MNP",
    "iata": "MP",
    "prefix": "+1670"
  },
  {
    "name": "Mozambique",
    "code": "MOZ",
    "iata": "MZ",
    "prefix": "+258"
  },
  {
    "name": "Mauritania",
    "code": "MRT",
    "iata": "MR",
    "prefix": "+222"
  },
  {
    "name": "Montserrat",
    "code": "MSR",
    "iata": "MS",
    "prefix": "+1664"
  },
  {
    "name": "Martinique",
    "code": "MTQ",
    "iata": "MQ",
    "prefix": "+596"
  },
  {
    "name": "Mauritius",
    "code": "MUS",
    "iata": "MU",
    "prefix": "+230"
  },
  {
    "name": "Malawi",
    "code": "MWI",
    "iata": "MW",
    "prefix": "+265"
  },
  {
    "name": "Malaysia",
    "code": "MYS",
    "iata": "MY",
    "prefix": "+60"
  },
  {
    "name": "Mayotte",
    "code": "MYT",
    "iata": "YT",
    "prefix": "+262"
  },
  {
    "name": "Namibia",
    "code": "NAM",
    "iata": "NA",
    "prefix": "+264"
  },
  {
    "name": "New Caledonia",
    "code": "NCL",
    "iata": "NC",
    "prefix": "+687"
  },
  {
    "name": "Niger",
    "code": "NER",
    "iata": "NE",
    "prefix": "+227"
  },
  {
    "name": "Norfolk Island",
    "code": "NFK",
    "iata": "NF",
    "prefix": "+672"
  },
  {
    "name": "Nigeria",
    "code": "NGA",
    "iata": "NG",
    "prefix": "+234"
  },
  {
    "name": "Nicaragua",
    "code": "NIC",
    "iata": "NI",
    "prefix": "+505"
  },
  {
    "name": "Niue",
    "code": "NIU",
    "iata": "NU",
    "prefix": "+683"
  },
  {
    "name": "Netherlands",
    "code": "NLD",
    "iata": "NL",
    "prefix": "+31"
  },
  {
    "name": "Norway",
    "code": "NOR",
    "iata": "NO",
    "prefix": "+47"
  },
  {
    "name": "Nepal",
    "code": "NPL",
    "iata": "NP",
    "prefix": "+977"
  },
  {
    "name": "Nauru",
    "code": "NRU",
    "iata": "NR",
    "prefix": "+674"
  },
  {
    "name": "New Zealand",
    "code": "NZL",
    "iata": "NZ",
    "prefix": "+64"
  },
  {
    "name": "Oman",
    "code": "OMN",
    "iata": "OM",
    "prefix": "+968"
  },
  {
    "name": "Pakistan",
    "code": "PAK",
    "iata": "PK",
    "prefix": "+92"
  },
  {
    "name": "Panama",
    "code": "PAN",
    "iata": "PA",
    "prefix": "+507"
  },
  {
    "name": "Pitcairn",
    "code": "PCN",
    "iata": "PN",
    "prefix": "+64"
  },
  {
    "name": "Peru",
    "code": "PER",
    "iata": "PE",
    "prefix": "+51"
  },
  {
    "name": "Philippines",
    "code": "PHL",
    "iata": "PH",
    "prefix": "+63"
  },
  {
    "name": "Palau",
    "code": "PLW",
    "iata": "PW",
    "prefix": "+680"
  },
  {
    "name": "Papua New Guinea",
    "code": "PNG",
    "iata": "PG",
    "prefix": "+675"
  },
  {
    "name": "Poland",
    "code": "POL",
    "iata": "PL",
    "prefix": "+48"
  },
  {
    "name": "Puerto Rico",
    "code": "PRI",
    "iata": "PR",
    "prefix": "+1787"
  },
  {
    "name": "North Korea",
    "code": "PRK",
    "iata": "KP",
    "prefix": "+850"
  },
  {
    "name": "Portugal",
    "code": "PRT",
    "iata": "PT",
    "prefix": "+351"
  },
  {
    "name": "Paraguay",
    "code": "PRY",
    "iata": "PY",
    "prefix": "+595"
  },
  {
    "name": "Palestine",
    "code": "PSE",
    "iata": "PS",
    "prefix": "+970"
  },
  {
    "name": "French Polynesia",
    "code": "PYF",
    "iata": "PF",
    "prefix": "+689"
  },
  {
    "name": "Qatar",
    "code": "QAT",
    "iata": "QA",
    "prefix": "+974"
  },
  {
    "name": "Réunion",
    "code": "REU",
    "iata": "RE",
    "prefix": "+262"
  },
  {
    "name": "Romania",
    "code": "ROU",
    "iata": "RO",
    "prefix": "+40"
  },
  {
    "name": "Russian",
    "code": "RUS",
    "iata": "RU",
    "prefix": "+7"
  },
  {
    "name": "Rwanda",
    "code": "RWA",
    "iata": "RW",
    "prefix": "+250"
  },
  {
    "name": "Saudi Arabia",
    "code": "SAU",
    "iata": "SA",
    "prefix": "+966"
  },
  {
    "name": "Sudan",
    "code": "SDN",
    "iata": "SD",
    "prefix": "+249"
  },
  {
    "name": "Senegal",
    "code": "SEN",
    "iata": "SN",
    "prefix": "+221"
  },
  {
    "name": "Singapore",
    "code": "SGP",
    "iata": "SG",
    "prefix": "+65"
  },
  {
    "name": "South Georgia and the South Sandwich Islands",
    "code": "SGS",
    "iata": "GS",
    "prefix": "+500"
  },
  {
    "name": "Saint Helena",
    "code": "SHN",
    "iata": "SH",
    "prefix": "+290"
  },
  {
    "name": "Svalbard and Jan Mayen",
    "code": "SJM",
    "iata": "SJ",
    "prefix": "+47"
  },
  {
    "name": "Solomon Islands",
    "code": "SLB",
    "iata": "SB",
    "prefix": "+677"
  },
  {
    "name": "Sierra Leone",
    "code": "SLE",
    "iata": "SL",
    "prefix": "+232"
  },
  {
    "name": "El Salvador",
    "code": "SLV",
    "iata": "SV",
    "prefix": "+503"
  },
  {
    "name": "San Marino",
    "code": "SMR",
    "iata": "SM",
    "prefix": "+378"
  },
  {
    "name": "Somalia",
    "code": "SOM",
    "iata": "SO",
    "prefix": "+252"
  },
  {
    "name": "Saint Pierre and Miquelon",
    "code": "SPM",
    "iata": "PM",
    "prefix": "+508"
  },
  {
    "name": "Serbia",
    "code": "SRB",
    "iata": "RS",
    "prefix": "+381"
  },
  {
    "name": "South Sudan",
    "code": "SSD",
    "iata": "SS",
    "prefix": "+211"
  },
  {
    "name": "Sao Tome and Principe",
    "code": "STP",
    "iata": "ST",
    "prefix": "+239"
  },
  {
    "name": "Suriname",
    "code": "SUR",
    "iata": "SR",
    "prefix": "+597"
  },
  {
    "name": "Slovakia",
    "code": "SVK",
    "iata": "SK",
    "prefix": "+421"
  },
  {
    "name": "Slovenia",
    "code": "SVN",
    "iata": "SI",
    "prefix": "+386"
  },
  {
    "name": "Sweden",
    "code": "SWE",
    "iata": "SE",
    "prefix": "+46"
  },
  {
    "name": "Swaziland",
    "code": "SWZ",
    "iata": "SZ",
    "prefix": "+268"
  },
  {
    "name": "Sint Maarten",
    "code": "SXM",
    "iata": "SX",
    "prefix": "+1721"
  },
  {
    "name": "Seychelles",
    "code": "SYC",
    "iata": "SC",
    "prefix": "+248"
  },
  {
    "name": "Syria",
    "code": "SYR",
    "iata": "SY",
    "prefix": "+963"
  },
  {
    "name": "Turks and Caicos Islands",
    "code": "TCA",
    "iata": "TC",
    "prefix": "+1649"
  },
  {
    "name": "Chad",
    "code": "TCD",
    "iata": "TD",
    "prefix": "+235"
  },
  {
    "name": "Togo",
    "code": "TGO",
    "iata": "TG",
    "prefix": "+228"
  },
  {
    "name": "Thailand",
    "code": "THA",
    "iata": "TH",
    "prefix": "+66"
  },
  {
    "name": "Tajikistan",
    "code": "TJK",
    "iata": "TJ",
    "prefix": "+992"
  },
  {
    "name": "Tokelau",
    "code": "TKL",
    "iata": "TK",
    "prefix": "+690"
  },
  {
    "name": "Turkmenistan",
    "code": "TKM",
    "iata": "TM",
    "prefix": "+993"
  },
  {
    "name": "East Timor",
    "code": "TLS",
    "iata": "TL",
    "prefix": "+670"
  },
  {
    "name": "Tonga",
    "code": "TON",
    "iata": "TO",
    "prefix": "+676"
  },
  {
    "name": "Trinidad and Tobago",
    "code": "TTO",
    "iata": "TT",
    "prefix": "+1868"
  },
  {
    "name": "Tunisia",
    "code": "TUN",
    "iata": "TN",
    "prefix": "+216"
  },
  {
    "name": "Turkey",
    "code": "TUR",
    "iata": "TR",
    "prefix": "+90"
  },
  {
    "name": "Tuvalu",
    "code": "TUV",
    "iata": "TV",
    "prefix": "+688"
  },
  {
    "name": "Taiwan",
    "code": "TWN",
    "iata": "TW",
    "prefix": "+886"
  },
  {
    "name": "Tanzania",
    "code": "TZA",
    "iata": "TZ",
    "prefix": "+255"
  },
  {
    "name": "Uganda",
    "code": "UGA",
    "iata": "UG",
    "prefix": "+256"
  },
  {
    "name": "Ukraine",
    "code": "UKR",
    "iata": "UA",
    "prefix": "+380"
  },
  {
    "name": "United States Minor Outlying Islands",
    "code": "UMI",
    "iata": "UM",
    "prefix": "+1"
  },
  {
    "name": "Uruguay",
    "code": "URY",
    "iata": "UY",
    "prefix": "+598"
  },
  {
    "name": "United States",
    "code": "USA",
    "iata": "US",
    "prefix": "+1"
  },
  {
    "name": "Uzbekistan",
    "code": "UZB",
    "iata": "UZ",
    "prefix": "+998"
  },
  {
    "name": "Holy See (Vatican)",
    "code": "VAT",
    "iata": "VA",
    "prefix": "+379"
  },
  {
    "name": "Saint Vincent Grenadines",
    "code": "VCT",
    "iata": "VC",
    "prefix": "+1784"
  },
  {
    "name": "Venezuela",
    "code": "VEN",
    "iata": "VE",
    "prefix": "+58"
  },
  {
    "name": "Virgin Islands (British)",
    "code": "VGB",
    "iata": "VG",
    "prefix": "+1284"
  },
  {
    "name": "U.S. Virgin Islands",
    "code": "VIR",
    "iata": "VI",
    "prefix": "+1340"
  },
  {
    "name": "Viet Nam",
    "code": "VNM",
    "iata": "VN",
    "prefix": "+84"
  },
  {
    "name": "Vanuatu",
    "code": "VUT",
    "iata": "VU",
    "prefix": "+678"
  },
  {
    "name": "Wallis and Futuna",
    "code": "WLF",
    "iata": "WF",
    "prefix": "+681"
  },
  {
    "name": "Samoa",
    "code": "WSM",
    "iata": "WS",
    "prefix": "+685"
  },
  {
    "name": "Kosovo",
    "code": "XKX",
    "iata": "XK",
    "prefix": "+383"
  },
  {
    "name": "Yemen",
    "code": "YEM",
    "iata": "YE",
    "prefix": "+967"
  },
  {
    "name": "South Africa",
    "code": "ZAF",
    "iata": "ZA",
    "prefix": "+27"
  },
  {
    "name": "Zambia",
    "code": "ZMB",
    "iata": "ZM",
    "prefix": "+260"
  },
  {
    "name": "Zimbabwe",
    "code": "ZWE",
    "iata": "ZW",
    "prefix": "+263"
  }
]
